import { trackingService } from 'config/trackingService';
import { eventTypeTracking } from 'config/types';
import { urls } from 'constants/urls';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { useGlobals } from 'hooks/useGlobals';
import { Params, ParamsTracking } from './types';

export function useSendTracking() {
  const { isMobile, isTablet } = useDeviceSize();

  const device = isMobile || isTablet ? 'mobile' : 'desktop';
  const globals = useGlobals();

  const buildTrackingData = ({ userId, nameEvent, clickEvent, data }: ParamsTracking) => ({
    url: window.location.href,
    referrer: window.location.href,
    user: {
      user_id: userId,
      user_realm: 'shipper',
    },
    event: {
      name: nameEvent,
      data,
      meta: {
        click: {
          isTrusted: true,
          posX: clickEvent?.clientX,
          posY: clickEvent?.clientY,
        },
      },
    },
  });

  const sendTrackingJaiminho = (params: Params, eventType: eventTypeTracking) => {
    const getUserIdHashed = globals?.user?.data?.id_hashed;
    const paramsFormated = {
      userId: getUserIdHashed ? `hashed|${getUserIdHashed}` : null,
      ...params,
    };

    const data = buildTrackingData(paramsFormated);

    trackingService(eventType).post(urls.tracking.jaiminho, { device, ...data });
  };

  return {
    sendTrackingJaiminho,
  };
}
